import { PluginIdentifier } from "@bitwarden/web-vault/app/services/store/data-plugin/plugin-identifier";

/**
 * Plugin Metadata
 *
 * This file contains the display metadata for plugins shown in the UI.
 * The plugin `id` field must match the `name` field in the corresponding
 * PluginConfig in external.bookt-transaction.store.collection.ts
 *
 * For example:
 * - PluginMetadata { id: "opal-card", ... }
 * - PluginConfig { name: "opal-card", ... }
 */

export const DEFAULT_PLUGIN_LOGO = "images/logo-white-1024square-transparent.png";

export interface PluginMetadata {
  id: string;
  displayName: string;
  imagePath: string;
  enabled?: boolean;
  supportsUserSwitch?: boolean;
  /**
   * Institution name shown on accounts this plugin creates, in place of the generic "Other"
   * institution every plugin falls back to otherwise (e.g. "Opal Jane" instead of "Other Jane") —
   * see getPluginInstitution (plugin-institution.helper.ts). Omit to keep the "Other" fallback;
   * add per plugin as each one's naming is confirmed.
   */
  institutionName?: string;
}

export const AVAILABLE_PLUGINS: PluginMetadata[] = [
  {
    id: PluginIdentifier.TRANSACTION,
    displayName: "Transaction Detector",
    imagePath: DEFAULT_PLUGIN_LOGO,
    enabled: true,
  },
  {
    id: "blockstream",
    displayName: "Crypto (Blockstream)",
    imagePath: "images/plugins/opal.png", // TODO: Replace with crypto.png when available
  },
  {
    id: "ethvm",
    displayName: "Ethereum",
    imagePath: "images/plugins/opal.png", // TODO: Replace with ethvm.png when available
  },
  {
    id: "solana",
    displayName: "Solana",
    imagePath: "images/plugins/solana.png",
  },
  {
    id: "opal-card",
    displayName: "Opal Card",
    imagePath: "images/plugins/opal.png",
    supportsUserSwitch: true,
    institutionName: "Opal",
  },
  {
    id: "gift-card",
    displayName: "Gift Card",
    imagePath: "images/plugins/opal.png", // TODO: Replace with gift-card.png when available
  },
  {
    id: "super",
    displayName: "Superannuation",
    imagePath: "images/plugins/super.png",
  },
];

/**
 * Get plugin metadata by ID
 */
export function getPluginMetadata(pluginId: string): PluginMetadata | undefined {
  return AVAILABLE_PLUGINS.find((p) => p.id === pluginId);
}
